var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"hera-title secondary-font",class:[("hera-title--" + _vm.variant)]},[_c('TextBlock',_vm._b({},'TextBlock',{
      size: 1.5,
      variant: 'primary',
      lineHeight: 1.5,
      text: _vm.text,
      tag: _vm.tag,
    },false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }